import React from "react";
import css from "./section.module.css";

const Location = ({ data }) => {
  const { image, name, address } = data;
  return (
    <div className={css.single_location}>
      <img className={css.image} src={image} alt="Location" />
      <div className={css.overlay}>
        <h4>{name}</h4>
        <p>{address}</p>
      </div>
    </div>
  );
};

export default Location;
